import "./styles.less";

import { Col, Row, Skeleton, Space } from "antd";
import { ImageProps, usePropertyCover } from "./hook";
import React, { FC, useContext, useEffect, useState } from "react";

import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import { Favorite } from "../../../Components/Property/Favorite/web";
import { ListingTypeTag } from "../../../Components/Property/ListingTypeTag/web";
import { PropertyCoverTags } from "./PropertyCoverTag/web";
import { ReportButton } from "../../../Components/Property/ReportButton/web";
import { SocialShare } from "../../../Components/Property/SocialShare/web";
import { TourIframe } from "../PropertyModal/PropertyModalTour3d/web";
import { useTheme } from "../../../Styles/ThemeHook";
import { ListingTag } from "src/contexts/ListingTags/ListingTagsProvider";
import usePropertyData from "src/hooks/propertyData/usePropertyData";
import { ImagenOptimizada } from "shared-components/Components/Image/_new_web";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";
import {
	DataImages,
} from "../../../Components/Property/PropertyCard/CardImageGallery/web";
import { EmblaGalleryCarousel } from "src/Components/EmblaCarousel";

const ImageHeader: FC<{ data: any; loading: boolean; tourUrl: string; propertyId: number }> = ({
	data,
	loading,
	tourUrl,
	propertyId
}) => {
	if (loading) {
		return <Skeleton.Image />;
	}

	return tourUrl ? (
		<TourIframe url={tourUrl} />
	) : (
		<ImagenOptimizada src={data.img} alt="Image" width={742} height={400} imageId={data.images[0]?.id} propertyId={String(propertyId)} />
	);
};

export const PropertyCover: FC<ImageProps> = ({
	id,
	mode = "auto",
	onTabClick,
	loading = false,
	images,
	img,
	isProject,
	tour3d,
	files,
	latitude,
	isEspecial,
	isDisabledProperty = false,
}) => {
	const screens = useWindowSize();
	const { data } = usePropertyCover(mode, images, isProject, img);
	const { theme } = useTheme();
	const screen = useBreakpoint();
	const { country_code } = useContext(ConfigStateContext);
	const { listing } = usePropertyData();
	const [dataTags, setDataTags] = useState<ListingTag>({} as ListingTag)
	const isMobile = !screens.xl && !screens.lg;

	if (!data) return null;

	const fullWidth = data?.images?.length <= 2;
	const gridWidth = data?.images?.length >= 5;
	const tabToSelect = tour3d ? "tour3d" : "photos";

	const GRID_NORMAL_IMAGES_3 = (
		<>
			<Col span={24} lg={fullWidth ? 24 : 18}>
				<ImageHeader data={data} tourUrl={tour3d} loading={loading} propertyId={Number(id)} />
			</Col>
			{!fullWidth && (
				<Col span={0} lg={6} className="left">
					<Row gutter={[0, theme.spacing.smSpacing]}>
						<Col span={24}>
							{loading ? (
								<Skeleton.Image />
							) : (
								<ImagenOptimizada src={data.images[1]?.image} alt="Image" height={210} imageId={data.images[1]?.id} propertyId={Number(id)} />
							)}
						</Col>
						<Col span={24}>
							{loading ? (
								<Skeleton.Image />
							) : (
								<ImagenOptimizada src={data.images[2]?.image} alt="Image" height={210} imageId={data.images[2]?.id} propertyId={Number(id)} />
							)}
						</Col>
					</Row>
				</Col>
			)}
		</>
	);

	const GRID_ESPECIAL_IMAGES_3 = (
		<>
			<Col span={24} lg={fullWidth ? 24 : 16}>
				<div className="item-image">
					<div className="hover-zoom-in">
						<ImageHeader data={data} tourUrl={tour3d} loading={loading} propertyId={Number(id)} />
					</div>
				</div>
			</Col>
			{!fullWidth && (
				<Col span={0} lg={8} className="left">
					<Row gutter={[theme.spacing.smSpacing, theme.spacing.smSpacing]}>
						<Col span={24}>
							{loading ? (
								<Skeleton.Image />
							) : (
								<div className="item-image">
									<div className="hover-zoom-in">
										<ImagenOptimizada src={data.images[1]?.image} alt="Image" height={210} imageId={data.images[1]?.id} propertyId={Number(id)} />
									</div>
								</div>
							)}
						</Col>
						<Col span={24}>
							{loading ? (
								<Skeleton.Image />
							) : (
								<div className="item-image">
									<div className="hover-zoom-in">
										<ImagenOptimizada
											src={data.images[2]?.image}
											alt="Image"
											height={210}
											imageId={data.images[2]?.id}
											propertyId={id}
										/>
										<button type="button" className="img-overlay">
											<p className="max-property">{`+${data.images.length}`}</p>
											<p className="view-more">Ver más</p>
										</button>
									</div>
								</div>
							)}
						</Col>
					</Row>
				</Col>
			)}
		</>
	);

	const GRID_IMAGES_5 = (
		<>
			<Col span={24} md={12}>
				<div className="item-image">
					<div className="hover-zoom-in">
						<ImageHeader data={data} tourUrl={tour3d} loading={loading} propertyId={Number(id)} />
					</div>
				</div>
			</Col>
			<Col span={0} md={12} className="left">
				<Row gutter={[theme.spacing.smSpacing, theme.spacing.smSpacing]}>
					<Col span={12}>
						{loading ? (
							<Skeleton.Image />
						) : (
							<div className="item-image">
								<div className="hover-zoom-in">
									<ImagenOptimizada src={data?.images[1]?.image} alt="Image" height={210} imageId={data?.images[1]?.id} propertyId={Number(id)} />
								</div>
							</div>
						)}
					</Col>
					<Col span={12}>
						{loading ? (
							<Skeleton.Image />
						) : (
							<div className="item-image">
								<div className="hover-zoom-in">
									<ImagenOptimizada src={data?.images[2]?.image} alt="Image" height={210} imageId={data.images[2]?.id} propertyId={Number(id)} />
								</div>
							</div>
						)}
					</Col>
					<Col span={12}>
						{loading ? (
							<Skeleton.Image />
						) : (
							<div className="item-image">
								<div className="hover-zoom-in">
									<ImagenOptimizada src={data?.images[3]?.image} alt="Image" height={210} imageId={data.images[3]?.id} propertyId={Number(id)} />
								</div>
							</div>
						)}
					</Col>
					<Col span={12}>
						{loading ? (
							<Skeleton.Image />
						) : (
							<div className="item-image">
								<div className="hover-zoom-in">
									<ImagenOptimizada
										src={data?.images[4]?.image}
										alt="Image"
										height={210}
										imageId={data.images[4]?.id}
										propertyId={String(id)}
									/>
									<button type="button" className="img-overlay">
										<p className="max-property">{`+${data.images.length}`}</p>
										<p className="view-more">Ver más</p>
									</button>
								</div>
							</div>
						)}
					</Col>
				</Row>
			</Col>
		</>
	);

	const COVER_GRADIENT = (
		<div
			className="cover-gradient"
			onClick={loading ? null : () => { onTabClick(tabToSelect) }}></div>
	);


	useEffect(() => {
		if (listing) {
			setDataTags({
				id: listing.id,
				seaDistanceName: listing.seaDistanceName,
				isProject: isProject,
				highlight: listing.highlight,
				owner: listing.owner,
				isExternal: listing.isExternal,
				tour3d: listing.tour3d,
				link: listing.link,
				legacy_propID: listing.legacy_propID,
				title: listing.title,
				tag: listing.tag
			})
		}
	}, [listing])

	return (
		<div
			className={`property_details_cover ${isEspecial
				? `property-details-cover-especial ${fullWidth ? "fullWidth" : ""}`
				: ""
				}`}>
			{isEspecial ? fullWidth && COVER_GRADIENT : COVER_GRADIENT}
			<Row className={"top-tags-buttons"}>
				{(!isEspecial && id !== "" && dataTags.id) && (
					<Col flex={1}>
						<ListingTypeTag id={id} data={dataTags} />
					</Col>
				)}
				<Col>
					<div className={screen.lg ? "box-buttons" : "box-buttons box-buttons--mobile"}>
						{!isProject &&
							<Favorite
								id={id}
								isDisabledProperty={isDisabledProperty}
								isEspecial={isEspecial}
								type={`${screen.lg ? "default" : "justIcon"}`}
							/>}
						<SocialShare
							id={id}
							mode={mode}
							isEspecial={isEspecial}
							type={`${screen.lg ? "default" : "justIcon"}`}
							isDisabledProperty={isDisabledProperty}
						/>
						{country_code != "BR" && mode != "project" && (
							<ReportButton
								isDisabledProperty={isDisabledProperty}
								id={id}
								mode={mode}
								type={`${screen.lg ? "default" : "justIcon"}`}
								isEspecial={isEspecial}
							/>
						)}
					</div>
				</Col>
			</Row>
			<Row className={"bottom-card-tags"}>
				<Col>
					<PropertyCoverTags
						onClick={tab => onTabClick(tab)}
						imageCount={isEspecial ? 0 : data.images.length || data.img && 1 || 0}
						files={files}
						youtube={listing?.youtube ? listing?.youtube : listing?.video}
						latitude={latitude}
						tour3d={tour3d}
						loading={loading}
					/>
				</Col>
			</Row>
			{/* <Row
				gutter={theme.spacing.smSpacing}
				className={"property-cover-gallery"}
				onClick={loading ? null : () => onTabClick(tabToSelect)}> */}
			{/* {!isEspecial
					? GRID_NORMAL_IMAGES_3
					: gridWidth
						? GRID_IMAGES_5
						: GRID_ESPECIAL_IMAGES_3} */}
			{data?.images && data?.images.length > 0 ? (
				<EmblaGalleryCarousel
					title={`gallery-slide${id}`}
					totalSlides={data?.images.length}
					hasflag={data?.isProject && data?.fair?.active}
					rel={data?.isExternal ? "nofollow" : null}
					options={{
						navigation: true,
						pagination: true,
						loop: true
					}}
					link={"#"}
					handleClick={loading ? null : () => onTabClick(tabToSelect)}
				>
					{images.map((g: DataImages, i: number) => {
						const keyValue = `gallery-${g.id ?? id}-listing-item-${i}`;

						return (
							<div className={"gallery-image embla__slide__number"} key={keyValue}>
								<ImagenOptimizada
									src={g.image ?? ""}
									alt="Image"
									width={"100%"}
									height={"auto"}
									propertyId={id}
								/>
							</div>
						);
					})}
				</EmblaGalleryCarousel>
			) : (
				<></>
			)}
			{/* </Row> */}
		</div>
	);
};
